/**
 * Canonical engagement-request routes under the /engagements/* path prefix.
 *
 * These mirror the embed-side paths that Vue sends as child paths in
 * host:init / host:set-location messages (e.g. "/engagements/list").
 * They live under the path prefix Angular receives when embedded in the Vue
 * host shell, and are reused for the standalone Angular shell as well.
 *
 * Gated behind MODULE_OUTSCAN — the menu item and pages are only visible when
 * the outscan module is licensed and enabled for the scope.
 */
import { Routes } from '@angular/router';
import { AsmAuthority } from '@asm/components-core/models/asm-authority';
import { AsmRouteId } from '@asm/components-core/models/asm-route-id';
import { RouterTools } from '@sol/components';

export const routesEngagementRequests: Routes = [
  // /engagements → /engagements/overview
  RouterTools.ofRedirect(AsmRouteId.engagementRequests, AsmRouteId.engagementRequests_overview),

  // /engagements/overview
  RouterTools.ofLazy(
    AsmRouteId.engagementRequests_overview,
    () =>
      import('@asm/components-engagements/components/settings/asm-engagement-requests-overview-page/asm-engagement-requests-overview-page.component').then(
        m => m.AsmEngagementRequestsOverviewPageComponent,
      ),
    [AsmAuthority.MODULE_OUTSCAN],
  ),

  // /engagements/list
  RouterTools.ofLazy(
    AsmRouteId.engagementRequests_list,
    () =>
      import('@asm/components-engagements/components/settings/asm-engagement-requests-page/asm-engagement-requests-page.component').then(
        m => m.AsmEngagementRequestsPageComponent,
      ),
    [AsmAuthority.MODULE_OUTSCAN],
  ),

  // /engagements/accounts
  RouterTools.ofLazy(
    AsmRouteId.engagementRequests_accounts,
    () =>
      import('@asm/components-engagements/components/settings/asm-engagement-accounts-page/asm-engagement-accounts-page.component').then(
        m => m.AsmEngagementAccountsPageComponent,
      ),
    [AsmAuthority.MODULE_OUTSCAN],
  ),

  // /engagements/:id → /engagements/:id/overview
  RouterTools.ofRedirect(AsmRouteId.engagementRequests_detail, AsmRouteId.engagementRequests_detail_overview),

  // /engagements/:id/overview
  RouterTools.ofLazy(
    AsmRouteId.engagementRequests_detail_overview,
    () =>
      import('@asm/components-engagements/components/settings/asm-engagement-request-detail-page/asm-engagement-request-detail-page.component').then(
        m => m.AsmEngagementRequestDetailPageComponent,
      ),
    [AsmAuthority.MODULE_OUTSCAN],
  ),

  // /engagements/:id/comments
  RouterTools.ofLazy(
    AsmRouteId.engagementRequests_detail_comments,
    () =>
      import('@asm/components-engagements/components/settings/asm-engagement-request-detail-page/asm-engagement-request-detail-page.component').then(
        m => m.AsmEngagementRequestDetailPageComponent,
      ),
    [AsmAuthority.MODULE_OUTSCAN],
  ),
];
